import { render, staticRenderFns } from "./CompanyIntro.vue?vue&type=template&id=7c29f120&scoped=true"
import script from "./CompanyIntro.vue?vue&type=script&lang=js"
export * from "./CompanyIntro.vue?vue&type=script&lang=js"
import style0 from "./CompanyIntro.vue?vue&type=style&index=0&id=7c29f120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c29f120",
  null
  
)

export default component.exports